import {css} from 'lit';
export const styles = css`:host {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

ef-copy-box-block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 2px 4px;
  font-size: 0.9em;
  color: var(--primary);
  word-break: break-word;
}

button {
  background: transparent;
  border: transparent;
  font-weight: 600;
  color: var(--primary);
  margin-top: 8px;
}

::slotted(*) {
  width: 100%;
}
`;
export default styles;
